<div class="heading">С этим товаром часто покупают</div>
<div class="set">
    <div class="set-item set-item-selected">
        <div class="item item-image"><img src="{fields.picture}" alt="{fields.name}"></div>
        <div class="item item-title">{fields.name}</div>
        <div class="item item-price">
                <div class="price">{formatPrice(fields.price_result)}</div>
            {#if fields.price_result != fields.price}
                <div class="price price-old">{formatPrice(fields.price)}</div>
            {/if}
        </div>
        <div class="item-sticker item-stiker-left">Ваш товар</div>
    </div>
    {#each items as {name, picture, url, price_result, price, is_deleted }, row }
        <div class="set-item {is_deleted ? 'set-item-deleted' : ''}">
            <div class="item item-image"><img src="{picture}" alt="{name}"></div>
            <a href="{url}" target="_blank" class="item item-title">{name}</a>
            <div class="item item-price">
                    <div class="price">{price_result}</div>
                {#if price_result != price}
                    <div class="price price-old">{price}</div>
                {/if}
            </div>
            <div class="set-sign">+</div>
            {#if is_deleted}
                <div class="set-sign set-sign-top" on:click="changeDeleted(row)">+</div>
            {:else}
                <div class="set-sign set-sign-top" on:click="changeDeleted(row)"><img src="/local/images/delete.svg" alt=""></div>
            {/if}
        </div>
    {/each}
    <div class="set-item set-item-result">
        <div class="price price-result">{formatPrice(price_result)}</div>
         {#if price_result != price_sum}
            <div class="price price-old">{formatPrice(price_sum)}</div>
        {/if}
        <div class="btn btn-orange" on:click="sendBasket()">В корзину</div>
        <a href="{extra_access}" class="btn">Собрать свой комплект</a>
        <div class="set-sign">=</div>
    </div>
</div>
<script>
    export default {

        helpers: {
            formatPrice: (price) => price.toString().replace(/(\d)(?=(\d{3})+(\D|$))/g, '$1 ')+' руб.',
        },

        computed: {
            price_result: ({fields, items}) => fields.price_result + items
                    .filter(item=>!item.is_deleted)
                    .reduce((sum, item)=> sum+item.price_result_num, 0),
            price_sum: ({fields, items}) => fields.price + items
                    .filter(item=>!item.is_deleted)
                    .reduce((sum, item)=> sum+item.price_num, 0),
        },

        methods: {
            sendBasket(){
                let { fields, items, url_ajax, sessid } = this.get();
                let basket = items
                        .filter(item=>!item.is_deleted)
                        .reduce((acc, val)=>{acc.push(val.id);return acc}, []);
                basket.push(fields.id);

                this.on('received', (data) => {
                    location = 'https://'+location.host+'/personal/cart/';
                });

                this.fire('send', { action: 'sendBasket', code: fields.code, iblock_id: fields.iblock_id, basket, url_ajax, sessid });
            },
            changeDeleted(row){
                let { items } = this.get();
                items[row].is_deleted = !items[row].is_deleted;
                this.set({ items });
            },
        }

    }
</script>
<style type="text/scss">
img
{
	max-width: 100%;
	max-height: 100%;
	-o-object-fit: cover;
	object-fit: cover
}

.heading
{
	border-top: 1px solid #E7E8EA;
	font-family: robotobold;
	text-transform: uppercase;
	letter-spacing: 1px;
	margin-top: 30px;
	padding: 36px 24px;
	font-weight: 800;
	font-size: 14px;
	display: block
}

.set
{
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-flow: column nowrap;
	-ms-flex-flow: column nowrap;
	flex-flow: column nowrap;
	-webkit-box-pack: start;
	-webkit-justify-content: flex-start;
	-ms-flex-pack: start;
	justify-content: flex-start;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	padding: 0 24px
}

.set-item
{
	display: grid;
	grid-template-areas: "item-image item-title" "item-image item-title" "item-image item-price";
	grid-template-columns: minmax(0, 1fr) 2fr;
	grid-template-rows: 1fr 1fr 1fr;
	grid-column-gap: 10px;
	padding: 10px;
	height: 120px;
	border: 1px solid #E5E4E9;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	position: relative;
	min-height: 0;
	min-width: 0;
	width: 100%
}

.set-item-selected
{
	border-color: #00A3E2;
}

.set-item-result
{
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-webkit-flex-flow: column;
	-ms-flex-flow: column;
	flex-flow: column;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-justify-content: space-around;
	-ms-flex-pack: distribute;
	justify-content: center;
	border: none;
	height: 240px
}

.set-item-deleted
{
	opacity: .5;
	padding: 20px 16px
}

.set-item-deleted > .item
{
	-webkit-transform: scale(.9);
	-ms-transform: scale(.9);
	transform: scale(.9)
}

.set-sign
{
	position: absolute;
	top: -12.5px;
	left: 30px;
	background-color: #FFFFFF;
	border: 1px solid #E5E4E9;
	-webkit-border-radius: 50%;
	border-radius: 50%;
	width: 24px;
	height: 25px;
	z-index: 10;
	color: #B6B6B6;
	line-height: 25px;
	text-align: center
}

.set-sign-top
{
	height: 40px;
	width: 40px;
	top: unset;
	bottom: 5px;
	left: unset;
	right: 5px;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
	cursor: pointer;
	font-size: 28px
}

.set-sign-top img
{
	opacity: .2
}

.set-sign-top:hover
{
	border-color: #424345;
	color: #424345
}

.set-sign-top:hover > img
{
	opacity: 1
}

.item
{
	min-height: 0;
	min-width: 0;
	overflow: hidden
}

.item-image
{
	grid-area: item-image;
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
	width: 100%;
	height: 100%
}

.item-title
{
	grid-area: item-title;
	height: 100%;
	max-height: 70px;
	font-size: 14px;
	color: #000000;
	opacity: .6;
	overflow: hidden;
	-o-text-overflow: ellipsis;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	line-height: 17px;
	text-decoration: none
}

.item-title:hover
{
	color: #00B8FF;
}

.item-price
{
	grid-area: item-price;
	align-self: flex-end
}

.item-sticker
{
	position: absolute;
	top: 5px;
	left: 10px;
	color: #00A3E2;
	font-weight: 700;
	font-size: 14px
}

.item-sticker-left
{
	left: 0
}

.price
{
	white-space: nowrap;
	color: #000000;
	font-weight: 700
}

.price-old
{
	color: #6C7073;
	text-decoration: line-through;
	-webkit-text-decoration-color: #6C7073;
	text-decoration-color: #6C7073
}

.price-result
{
	font-size: 24px
}

.btn
{
	width: 100%;
	max-width: 290px;
	border: 1px solid #E5E4E9;
	-webkit-border-radius: 5px;
	border-radius: 5px;
	color: #666666;
	text-align: center;
	font-size: 16px;
	text-decoration: none;
	cursor: pointer;
	background-color: #FFF;
	border: 1px solid #C1C1C1;
	margin-top: 10px;
}

.btn:hover
{
	color: #413F3F;
	border: 1px solid #767676
}

.btn-orange
{
	background: #00A3E2;
	border-color: #00A3E2;
	color: #FFFFFF
}

.btn-orange:hover
{
	color: #FFFFFF;
	background: #00B8FF;
	border: 1px solid #00B8FF;
}

@media (min-width: 768px)
{
	.heading
	{
		font-size: 20px
	}

	.set
	{
		display: grid;
		grid-template-columns: repeat(3, minmax(160px, 2fr)) 3fr;
		grid-template-rows: 1fr
	}

	.set-item
	{
		height: 210px;
		-webkit-flex-basis: 160px;
		-ms-flex-preferred-size: 160px;
		flex-basis: 160px;
		grid-template-areas: "item-image" "item-image" "item-title" "item-price";
		grid-template-columns: 1fr;
		-webkit-box-align: center;
		-webkit-align-items: center;
		-ms-flex-align: center;
		align-items: center
	}

	.set-item-result
	{
		-webkit-box-flex: 2;
		-webkit-flex-grow: 2;
		-ms-flex-positive: 2;
		flex-grow: 2;
		padding-left: 30px
	}

	.set-sign
	{
		top: unset;
		left: -14px
	}

	.set-sign-top
	{
		height: 30px;
		width: 30px;
		top: 5px;
		bottom: unset;
		left: unset;
		right: 5px
	}

	.item
	{
		text-align: center
	}

	.btn
	{
		max-width: 220px;
		padding: 12px 16px
	}
}

@media (min-width: 1366px)
{
	.set
	{
		grid-template-columns: repeat(4, 1fr)
	}

	.set-item
	{
		height: 290px
	}

	.set-sign-top
	{
		top: 15px;
		bottom: unset;
		left: unset;
		right: 15px
	}

	.item-stiker-left
	{
		top: 15px;
		left: 15px
	}

	.price-result
	{
		font-size: 24px
	}
}
</style>